import { useAction } from "@api/actions/action";
import { useCallback, useEffect, useState } from "@wordpress/element";
import { ComponentRoute } from "./ComponentRoute";
import { dispatch } from "@wordpress/data";
import { store } from "../redux/store";

export function AdminRoutes() {
  const [loadingArticles, setLoadingArticles] = useState(true);
  const [loadingOpti, setLoadingOpti] = useState(true);
  const [optiArticles, setOptiArticles] = useState([]);
  const { mutateAsync } = useAction();

  const getArticlesOpti = useCallback(async () => {
    await mutateAsync('obter_usuario_opti')
      .then(res => {
        dispatch(store).setBlogIdOpti(parseInt(res?.data?.idUsuarioWordpress));
        dispatch(store).setUsuarioIdOpti(parseInt(res?.data?.idUsuarioOpti));
      })
      .finally(() => setLoadingOpti(false));
    await mutateAsync('get_articles_opti')
      .then(res => {
        setOptiArticles(res.data);
      })
      .finally(() => setLoadingArticles(false));
  }, []);

  useEffect(() => {
    localStorage.removeItem('token-opti');
    getArticlesOpti();
  }, [getArticlesOpti]);

  return (
    <ComponentRoute
      currentRoute={location.search}
      optiArticles={optiArticles}
      loading={loadingArticles || loadingOpti}
    />
  );
}
